import {patchState, signalStore, withComputed, withMethods, withProps, withState} from "@ngrx/signals";
import {computed, inject} from "@angular/core";
import {DeviceType} from "src/app/domain/devices/device";
import {LocationStore} from "src/app/domain/samples/location/location.store";
import {NfcLocationStore} from "src/app/domain/samples/nfc-location/nfc-location.store";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";

export enum HistoricalLocationFilter {
  TEN_LATEST = "Show ten latest locations",
  ALL = "Show all recent locations"
}

export interface HistoricalLocation {
  coords: number[];
  source?: string;
  instant: string;
  alertStatus?: Samples.AlertStatus;
}

interface HistoricalLocationsStoreState {
  deviceType: DeviceType | undefined
  filter: HistoricalLocationFilter
}

const initialState: HistoricalLocationsStoreState = {
  deviceType: undefined,
  filter: HistoricalLocationFilter.TEN_LATEST
}

const numberOfHistoricLocations = 10;

const mapGpsFixesToHistoricalLocations = (gpsFixes: Samples.AssetSample<Samples.GPSFix>[]): HistoricalLocation[] => {
  return gpsFixes.map(assetSample => {
    const sample = assetSample.sample;
    const value = sample.value;
    const coords = value.position!.coords!;
    const source = value.source;
    const instant = sample.instant;
    const alertStatus = assetSample.alertStatus;

    return {
      coords,
      source,
      instant,
      alertStatus
    };
  });
}

const mapNfcGpsFixesToHistoricalLocations = (nfcGpsFixes: Samples.AssetSample<Samples.NfcGpsFix>[]): HistoricalLocation[] => {
  return nfcGpsFixes.map(assetSample => {
    const sample = assetSample.sample;
    const value = sample.value;
    const coords = value.position!.coords!;
    const instant = sample.instant;

    return {
      coords,
      instant
    };
  });
}

export const HistoricalLocationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withProps(() => ({
    locationStore: inject(LocationStore),
    nfcLocationStore: inject(NfcLocationStore)
  })),
  withMethods(store => ({
    setDeviceType(deviceType: DeviceType) {
      patchState(store, { deviceType });
    },
    setFilter(filter: HistoricalLocationFilter) {
      patchState(store, { filter });
    }
  })),
  withComputed(({ deviceType, locationStore, nfcLocationStore, filter }) => ({
    filteredHistoricalLocations: computed(() => {
      console.log('[DEBUG historical-location.store] deviceType', deviceType(), 'filter', filter(), 'nfcSamples', nfcLocationStore.locationSamples().length, 'gpsSamples', locationStore.locationSamples().length);
      if (deviceType() === undefined) return [];

      if (deviceType() === DeviceType.NFC_TAG) {
        switch (filter()) {
          case HistoricalLocationFilter.ALL: {
            return mapNfcGpsFixesToHistoricalLocations(nfcLocationStore.locationSamples());
          }
          case HistoricalLocationFilter.TEN_LATEST: {
            return mapNfcGpsFixesToHistoricalLocations(nfcLocationStore.locationSamples().slice(0, numberOfHistoricLocations));
          }
        }
      } else {
        switch (filter()) {
          case HistoricalLocationFilter.ALL: {
            return mapGpsFixesToHistoricalLocations(locationStore.locationSamples());
          }
          case HistoricalLocationFilter.TEN_LATEST: {
            return mapGpsFixesToHistoricalLocations(locationStore.locationSamples().slice(0, numberOfHistoricLocations));
          }
        }
      }
    })
  }))
);
